export class TimeScale {
    private _frameCount: number;
    private _frameRate: number;

    constructor(frameCount: number, frameRate: number) {
        this._frameCount = frameCount;
        this._frameRate = frameRate;
    }

    get frameCount(): number {
        return this._frameCount;
    }

    get frameRate(): number {
        return this._frameRate;
    }

    public timeToFrame(time: number): number {
        return Math.floor(time * this._frameRate);
    }

    public frameToTime(frame: number): number {
        return frame / this._frameRate;
    }

    public timeToOffset(time: number): number {
        const frame = this.timeToFrame(time);
        return this.frameToOffset(frame);
    }

    public frameToOffset(frame: number): number {
        return (frame / this._frameCount) * 100;
    }

    public offsetToFrame(relativeOffset: number): number {
        return Math.floor(relativeOffset * this._frameCount);
    }
}
